import {InputStringStatePair, StatePair, useError, useInputString, useStatePair} from "../../../../type/States";
import {DataTransferObjectValidation} from "../../../../type/Types";
import {Button, Field, FieldProps, Input, Radio, RadioGroup} from "@fluentui/react-components";
import {Column, Row} from "../../common/Layout";
import {RouteContext} from "../../../RouteContext";
import {Styles} from "../../common/Styles";
import React from "react";
import {
    ShoppingParticipationPolicyDataTransferObject
} from "../../../../model/dto/content/ShoppingParticipationPolicyDataTransferObject";
import {ShoppingParticipationPolicyIO} from "../../../../io/content/ShoppingParticipationPolicyIO";

export default function Post(props: RouteContext) {
    const styles = Styles.useEditorStyles()

    const inputStates: Record<keyof ShoppingParticipationPolicyDataTransferObject.Post, InputStringStatePair> = {
        isDefaultValue: useInputString(''),
        limitedFigure: useInputString(''),
        firstFlagLocalTime: useInputString(''),
        secondFlagLocalTime: useInputString(''),
        allowedAmountMultiplier: useInputString(''),
    }
    const inputValidationStates: Record<keyof ShoppingParticipationPolicyDataTransferObject.Post, StatePair<FieldProps['validationState']>> = {
        isDefaultValue: useStatePair<FieldProps['validationState']>('none'),
        limitedFigure: useStatePair<FieldProps['validationState']>('none'),
        firstFlagLocalTime: useStatePair<FieldProps['validationState']>('none'),
        secondFlagLocalTime: useStatePair<FieldProps['validationState']>('none'),
        allowedAmountMultiplier: useStatePair<FieldProps['validationState']>('none'),
    }
    const postErrorState = useError()

    const onDoneClick = () => {
        inputValidationStates.isDefaultValue.setValue('none')
        inputValidationStates.limitedFigure.setValue('none')
        inputValidationStates.firstFlagLocalTime.setValue('none')
        inputValidationStates.secondFlagLocalTime.setValue('none')
        inputValidationStates.allowedAmountMultiplier.setValue('none')

        try {
            const dto: ShoppingParticipationPolicyDataTransferObject.Post = {
                isDefaultValue: DataTransferObjectValidation.validate(ShoppingParticipationPolicyDataTransferObject.Post.validation, 'isDefaultValue', inputStates.isDefaultValue.value, () => inputValidationStates.isDefaultValue.setValue('error')),
                limitedFigure: DataTransferObjectValidation.validate(ShoppingParticipationPolicyDataTransferObject.Post.validation, 'limitedFigure', inputStates.limitedFigure.value, () => inputValidationStates.limitedFigure.setValue('error')),
                firstFlagLocalTime: DataTransferObjectValidation.validate(ShoppingParticipationPolicyDataTransferObject.Post.validation, 'firstFlagLocalTime', inputStates.firstFlagLocalTime.value, () => inputValidationStates.firstFlagLocalTime.setValue('error')),
                secondFlagLocalTime: DataTransferObjectValidation.validate(ShoppingParticipationPolicyDataTransferObject.Post.validation, 'secondFlagLocalTime', inputStates.secondFlagLocalTime.value, () => inputValidationStates.secondFlagLocalTime.setValue('error')),
                allowedAmountMultiplier: DataTransferObjectValidation.validate(ShoppingParticipationPolicyDataTransferObject.Post.validation, 'allowedAmountMultiplier', inputStates.allowedAmountMultiplier.value, () => inputValidationStates.allowedAmountMultiplier.setValue('error')),
            }

            ShoppingParticipationPolicyIO.post(dto)
                .then((value: any)=>{
                    window.alert('추가되었습니다.')
                })
                .catch(postErrorState.setDefinedValue)

        } catch (error) {
            console.error(error)
        }
    }

    return <>
        <postErrorState.Dialog {...props} />
        <Column gap={'16px'}>
            <Field
                className={styles.field}
                label={ShoppingParticipationPolicyDataTransferObject.Post.description.isDefaultValue}
                validationState={inputValidationStates.isDefaultValue.value}>
            <RadioGroup
                value={inputStates.isDefaultValue.value}
                onChange={
                    (_, data) => {inputStates.isDefaultValue.setValue(data.value);}
                }>
                <Radio value="true" label="기본값 있음" checked={inputStates.isDefaultValue.value === 'true'} />
                <Radio value="false" label="기본값 없음" checked={inputStates.isDefaultValue.value === 'false'} />
            </RadioGroup>
            </Field>
            <Field
                className={styles.field}
                label={ShoppingParticipationPolicyDataTransferObject.Post.description.limitedFigure}
                validationState={inputValidationStates.limitedFigure.value}>
                <Input
                    value={inputStates.limitedFigure.value}
                    onChange={inputStates.limitedFigure.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingParticipationPolicyDataTransferObject.Post.description.firstFlagLocalTime}
                validationState={inputValidationStates.firstFlagLocalTime.value}
                validationMessage={"시간 형식을 지켜주세요 시간:분:초(HH:mm:ss)"}
            >
                <Input
                    value={inputStates.firstFlagLocalTime.value}
                    onChange={inputStates.firstFlagLocalTime.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingParticipationPolicyDataTransferObject.Post.description.secondFlagLocalTime}
                validationState={inputValidationStates.secondFlagLocalTime.value}
                validationMessage={"시간 형식을 지켜주세요 시간:분:초(HH:mm:ss)"}
            >
                <Input
                    value={inputStates.secondFlagLocalTime.value}
                    onChange={inputStates.secondFlagLocalTime.onChange} />
            </Field>
            <Field
                className={styles.field}
                label={ShoppingParticipationPolicyDataTransferObject.Post.description.allowedAmountMultiplier}
                validationState={inputValidationStates.allowedAmountMultiplier.value}
            >
                <Input
                    value={inputStates.allowedAmountMultiplier.value}
                    onChange={inputStates.allowedAmountMultiplier.onChange} />
            </Field>
            <Row>
                <Button
                    appearance={'primary'}
                    onClick={onDoneClick}>
                    완료
                </Button>
            </Row>
        </Column>
    </>
}